// Zuordnung der Lieder zu den Büchern: Quelle, Liednummer und Kategorien.
//   quelle 'wsvj' / 'anhang'  -> Jugendlieder
//   quelle 'wolga'            -> bleibt in der Datenbank, wird in der App nicht angezeigt
//   quelle 'eigene'           -> selbst hinzugefügte Lieder (Kürzel E)
//   keine Quelle (Altdaten)   -> Jugendlieder

const JUGENDLIEDER_KATEGORIEN = [
  'auferstehung',
  'evangelisation',
  'gebet',
  'gnade',
  'golgatha',
  'himmlische_heimat',
  'hingabe_und_dienst',
  'kampf_und_sieg',
  'kinderlieder',
  'lob_und_anbetung',
  'trost_und_vertrauen',
  'weihnachten',
  'wiederkunft_christi',
  'wort_gottes'
];

const KLEINE_WOERTER = new Set(['und', 'oder', 'von', 'vom', 'im', 'am', 'zu', 'zum', 'zur', 'der', 'die', 'das']);

// Nummer als Text, so wie sie in der Spalte `nummer` steht (nur die Zahl, z. B. 12).
// Fehlt sie (Altdaten), gilt die ID.
function nummerText(lied) {
  const nummer = lied?.nummer;
  if (nummer !== null && nummer !== undefined && String(nummer).trim() !== '') return String(nummer).trim();
  return String(lied?.id ?? '');
}

// Zahlenanteil der Nummer (für die Sortierung).
export function liednummer(lied) {
  const zahl = nummerText(lied).match(/\d+/);
  return zahl ? Number(zahl[0]) : Number(lied?.id);
}

// Sortierung nach Nummer: erst die Zahl, bei gleicher Zahl der Rest (12 vor 12a vor 12b).
export function vergleicheNummer(a, b) {
  return liednummer(a) - liednummer(b) || nummerText(a).localeCompare(nummerText(b), 'de', { numeric: true });
}

// Kürzel des Buchs je Quelle: J = Jugendlieder (auch der Anhang), E = selbst hinzugefügt.
// Lieder ohne Quelle (Altdaten) haben kein Kürzel.
const BUCH_KUERZEL = { wsvj: 'J', anhang: 'J', eigene: 'E' };

export function buchKuerzel(lied) {
  return BUCH_KUERZEL[lied?.quelle] || '';
}

// Nummer, wie sie in der Liste steht: nur die Zahl, ohne Buchstaben.
export function nummerAnzeige(lied) {
  return String(liednummer(lied));
}

// Nummer mit Kürzel (J12, W12): für die Suche und überall dort, wo beide Bücher gemischt sind und die Zahl allein nicht eindeutig wäre.
export function nummerMitKuerzel(lied) {
  return `${buchKuerzel(lied)}${nummerAnzeige(lied)}`;
}

// Lesbarer Name einer Kategorie.
export function kategorieLabel(kategorie) {
  if (!kategorie) return '';
  return kategorie
    .replace(/_/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((word, index) => {
      const lower = word.toLowerCase();
      if (index > 0 && KLEINE_WOERTER.has(lower)) return lower;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(' ');
}

// Kategorien der Jugendlieder (Kennung und Name), in der Reihenfolge des Buchs.
export function jugendKategorien() {
  return JUGENDLIEDER_KATEGORIEN.map((slug) => ({ slug, label: kategorieLabel(slug) }));
}
